module.exports = __webpack_public_path__ + "static/img/laranja.5c32d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/laranja.png
// module id = 7e0m
// module chunks = 0